module.exports = __webpack_public_path__ + "static/media/line2.bfe5957f.png";